import { Directive, Input } from "@angular/core";

@Directive({
  selector: "[color]",
})
export class ColorDirective {
  constructor() {}

  @Input() color: string;
}
